"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var language_1 = require("graphql/language");

var handler_1 = require("./handler");

var directivenode_1 = require("./handler/directivenode");

var IConvertContext_1 = require("./IConvertContext");

var Util_1 = require("./Util");
/**
 * Translate GraphQL queries into SPARQL algebra.
 */


var Converter =
/*#__PURE__*/
function () {
  function Converter(settings) {
    _classCallCheck(this, Converter);

    settings = settings || {};
    settings.variableDelimiter = settings.variableDelimiter || '_';
    settings.expressionVariableCounter = settings.expressionVariableCounter || 0;
    this.util = new Util_1.Util(settings);
    this.initializeNodeHandlers(settings);
  }

  _createClass(Converter, [{
    key: "graphqlToSparqlAlgebra",

    /**
     * Translates a GraphQL query into SPARQL algebra.
     * @param {string | DocumentNode} graphqlQuery A GraphQL query string or node.
     * @param {IContext} context A JSON-LD context.
     * @param {IConvertOptions} options An options object.
     * @return {Promise<Operation>} A promise resolving to an operation.
     */
    value: function graphqlToSparqlAlgebra(graphqlQuery, context, options) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.t1 = graphqlQuery;
                _context.next = 4;
                return this.util.contextParser.parse(context);

              case 4:
                _context.t2 = _context.sent;
                _context.t3 = options;
                return _context.abrupt("return", _context.t0.graphqlToSparqlAlgebraRawContext.call(_context.t0, _context.t1, _context.t2, _context.t3));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Translates a GraphQL query into SPARQL algebra.
     * @param {string | DocumentNode} graphqlQuery A GraphQL query string or node.
     * @param {IContext} context A JSON-LD context.
     * @param {IConvertOptions} options An options object.
     * @return {Operation} An operation.
     */

  }, {
    key: "graphqlToSparqlAlgebraRawContext",
    value: function graphqlToSparqlAlgebraRawContext(graphqlQuery, context, options) {
      options = options || {};
      var document = typeof graphqlQuery === 'string' ? language_1.parse(graphqlQuery) : graphqlQuery;
      var fragmentDefinitions = this.indexFragments(document);
      var convertContext = {
        context: context,
        fragmentDefinitions: fragmentDefinitions,
        graph: this.util.dataFactory.defaultGraph(),
        path: [],
        singularizeState: IConvertContext_1.SingularizeState.PLURAL,
        singularizeVariables: options.singularizeVariables || {},
        subject: null,
        terminalVariables: [],
        variablesDict: options.variablesDict || {},
        variablesMetaDict: {}
      };
      return this.util.handleNode(document, convertContext);
    }
    /**
     * Create an index of all fragment definitions in the given document.
     *
     * This will assign a new array of definition nodes without fragment definition.
     *
     * @param {DocumentNode} document A document node.
     * @return {{[p: string]: FragmentDefinitionNode}} An index of fragment definition nodes.
     */

  }, {
    key: "indexFragments",
    value: function indexFragments(document) {
      var fragmentDefinitions = {};
      var newDefinitions = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = document.definitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var definition = _step.value;

          if (definition.kind === 'FragmentDefinition') {
            fragmentDefinitions[definition.name.value] = definition;
          } else {
            newDefinitions.push(definition);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      document.definitions = newDefinitions;
      return fragmentDefinitions;
    }
  }, {
    key: "initializeNodeHandlers",
    value: function initializeNodeHandlers(settings) {
      Converter.registerNodeHandlers(this.util, settings);
      Converter.registerNodeValueHandlers(this.util, settings);
      Converter.registerDirectiveNodeHandlers(this.util, settings);
    }
  }], [{
    key: "registerNodeHandlers",
    value: function registerNodeHandlers(util, settings) {
      util.registerNodeHandler(new handler_1.NodeHandlerDocument(util, settings));
      util.registerNodeHandler(new handler_1.NodeHandlerDefinitionOperation(util, settings));
      util.registerNodeHandler(new handler_1.NodeHandlerDefinitionFragment(util, settings));
      util.registerNodeHandler(new handler_1.NodeHandlerSelectionFragmentSpread(util, settings));
      util.registerNodeHandler(new handler_1.NodeHandlerSelectionInlineFragment(util, settings));
      util.registerNodeHandler(new handler_1.NodeHandlerSelectionField(util, settings));
    }
  }, {
    key: "registerNodeValueHandlers",
    value: function registerNodeValueHandlers(util, settings) {
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerVariable(util, settings));
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerInt(util, settings));
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerFloat(util, settings));
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerString(util, settings));
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerBoolean(util, settings));
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerNull(util, settings));
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerEnum(util, settings));
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerList(util, settings));
      util.registerNodeValueHandler(new handler_1.NodeValueHandlerObject(util, settings));
    }
  }, {
    key: "registerDirectiveNodeHandlers",
    value: function registerDirectiveNodeHandlers(util, settings) {
      util.registerDirectiveNodeHandler(new directivenode_1.DirectiveNodeHandlerInclude(util, settings));
      util.registerDirectiveNodeHandler(new directivenode_1.DirectiveNodeHandlerOptional(util, settings));
      util.registerDirectiveNodeHandler(new directivenode_1.DirectiveNodeHandlerPlural(util, settings));
      util.registerDirectiveNodeHandler(new directivenode_1.DirectiveNodeHandlerSingle(util, settings));
      util.registerDirectiveNodeHandler(new directivenode_1.DirectiveNodeHandlerSkip(util, settings));
    }
  }]);

  return Converter;
}();

exports.Converter = Converter;